export default "__VITE_ASSET__CyYbcRNL__"